import styled, { createGlobalStyle } from 'styled-components'

export const AgentBotGlobalStyle = createGlobalStyle`
  #help-icon {
    display: none !important;
  }
  #overall-progress {
    display: none !important;
  }
`

export const WebChatWrapper = styled.div`
  height: 100vh;
  height: 100dvh;
  width: 100%;
`

export const WebchatContainer = styled.div`
  height: 100%;
`

export const Section = styled.div`
  height: 100%;
`

export const ChatAndSidebar = styled.div<{ $agentBot: boolean }>`
  display: ${props => (props.$agentBot ? 'block' : 'grid')};
  grid-template-columns: ${props => (props.$agentBot ? '1fr' : '1fr 1fr')};
  height: 100%;
  width: 100%;
  position: relative;
`

export const ChatPane = styled.div`
  height: 100%;
  min-height: 100%;
  position: relative;
  width: 100%;
`

export const ChatColumn = styled.div<{ $hidden?: boolean }>`
  display: ${props => (props.$hidden ? 'none' : 'block')};
  height: 100%;
  overflow-y: hidden;
  position: relative;
`

export const NothingToDo = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 12px;

  h3 {
    text-align: center;
  }
`

export const OverlayToggle = styled.div<{ $backToIncomeVerificationEnabled: boolean }>`
  width: 48%;
  margin-left: 1%;
  margin-bottom: 2%;
  box-sizing: border-box;
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  background: white;
  z-index: 998;
  animation: button-slide-in 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  border-top: 1px solid rgba(128, 128, 128, 0.26);

  @keyframes button-slide-in {
    0% {
      transform: translateY(85px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @media only screen and (max-width: 800px) {
    width: 100%;
    margin-left: 0;
    margin-bottom: 0;
    height: ${props => (props.$backToIncomeVerificationEnabled ? '110px' : '85px')};
    padding: 20px;
  }
`

export const PrimaryButton = styled.button`
  appearance: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.4;
  color: #2c3030;
  background-color: #34d9c3;
  padding: 10px 30px;
  width: 100%;
`

export const SecondaryButton = styled.button`
  appearance: none;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.4;
  color: #2c3030;
  background-color: #ffffff;
  padding: 10px 30px;
  width: 100%;
`

export const WebChatContainer = styled.div<{
  $hasSuggestedActions: boolean
  $hasAdaptiveCard: boolean
}>`
  display: block;
  position: relative;
  overflow: hidden;
  background: white;
  height: 100%;
  max-height: 95vh;
  min-height: 100%;
  border-radius: 10px;
  padding-top: 53px;
  font-size: 16px;
  letter-spacing: -0.01em;
  line-height: 20px;
  font-weight: 400;

  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(hsla(0, 0%, 100%, 0.25)),
    to(hsla(0, 0%, 100%, 0.25))
  );
  background-image: linear-gradient(
    180deg,
    hsla(0, 0%, 100%, 0.25),
    hsla(0, 0%, 100%, 0.25)
  );

  ::after {
    content: '';
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    pointer-events: none;
    width: 100%;
    height: 50px;
    border-radius: 10px;
  }

  @media (min-width: 800px) {
    height: 95vh;
    min-height: unset !important;
    padding-top: 0;
    box-shadow: 0 0 8px 2px rgba(100, 100, 100, 0.25);
    border-radius: 10px;
    margin: 15px;
  }

  .webchat__send-box .webchat__send-box__main {
    display: ${props =>
      props.$hasSuggestedActions || props.$hasAdaptiveCard ? 'none' : 'flex'} !important;
  }
`
